import { AffiliationPartnerData } from './../affiliation-partner.model';
import { FirestoreTimestampTimeAdapterService } from './../firestore-timestamp-time-adapter.service';
import { CarReservation, CarTypeData } from "./../itineray.model";
import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-itinerary-reservations-car-form",
  templateUrl: "./itinerary-reservations-car-form.component.html",
  styleUrls: ["./itinerary-reservations-car-form.component.css"]
})
export class ItineraryReservationsCarFormComponent implements OnInit {
  @Input()
  car: CarReservation;

  @Input()
  carId: number;

  @Input()
  npax: number;

  @Input()
  disabled: boolean;

  carTypesData = CarTypeData.values();

  constructor(public firestoreTimestampTimeAdapterService: FirestoreTimestampTimeAdapterService) { }

  affiliationPartnerData: AffiliationPartnerData[] = AffiliationPartnerData.values();

  ngOnInit() { }
}
